
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
  TextField,
  ThemeProvider,
  createTheme,
  CircularProgress,
  Divider,
  Alert,
  Tooltip,
  Zoom,
  Fade,
  Checkbox,
  FormControlLabel,
  Stack
} from '@mui/material';


import {
  Check as CheckIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import FactCheckerApi from '../apis/fact_checker';

import { Stepper, Step, StepLabel, StepContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import GetAppIcon from '@mui/icons-material/GetApp';
import ExtensionIcon from '@mui/icons-material/Extension';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TurnstileWidget from '../Components/TurnstileWidget';
import { useCallback, useRef } from 'react';


// This is the promotional banner that can be shown at the top of your main app
const ChromeExtensionBanner = ({ onClose, handleTutorialOpen }) => {
    const [isVisible, setIsVisible] = useState(true);
    
    const handleClose = () => {
      setIsVisible(false);
      if (onClose) onClose();
    };
  
  
    if (!isVisible) return null;
  
  
    return (
      <Paper
        elevation={3}
        sx={{
          p: 1.5,
          mb: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'linear-gradient(135deg, #4158D0 0%, #3c6ff6 50%, #2e8de5 100%)',
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '6px',
          color: 'white',
          // maxWidth: '800px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <InfoIcon sx={{ color: '#ffffff', mr: 1.5, fontSize: 24 }} />
          <Box sx={{ lineHeight: 0.8 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'white', mb: 0.5 }}>
              Take Truth Detection to the Next Level!
            </Typography>
            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: 1.2 }}>
              Install our Chrome extension to fact-check any website with just one click.
            </Typography>
          </Box>
        </Box>
  
        <Box sx={{ display: 'flex', gap: 2, ml: 2 }}>
          <Button
            variant="contained"
            size="small"
            startIcon={<ExtensionIcon sx={{ fontSize: 16 }} />}
            onClick={handleTutorialOpen}
            sx={{
              bgcolor: 'white',
              color: '#4158D0',
              fontWeight: 'bold',
              py: 0.5,
              px: 1.5,
              fontSize: '0.75rem',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.9)',
              }
            }}
          >
            Get Extension
          </Button>
  
          <IconButton
            onClick={handleClose}
            size="small"
            sx={{
              ml: 0.5,
              p: 0.5,
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.15)',
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Paper>
    );
  };

  export default ChromeExtensionBanner;